<template>
  <tile class="opc-zmone" ref="zmone-form">
    <zm-banner show-close v-if="licenseAlertDesc && !notification" type="info" show-icon class="opc-base-alert">
      <p class="opc-base-alert__message" v-html="licenseAlertDesc" @mouseover="licenseAlertMouseoverEventTrack" />
    </zm-banner>
    <zm-banner show-close v-if="notification" type="info" show-icon class="opc-base-alert">
      <p class="opc-base-alert__message" v-html="notification"  @mouseover="() => $tracking.buyInteraction('banner - product level', trackingPlanName + ' - ' + notification + ' - impression')" />
    </zm-banner>
    <CmrPaywallTip :type="cmrPaywallTipType" />
    <edu-switch-tip v-if="$context.is.edu2esc" :plan="$t('billing.planform.title.zo_edu_sch_cmp')"/>
    <foldable v-model="isExpanded" :title="title" :isRemoveWrapAriaLabelledby="true" :arrow="canExpand" :edit="canExpand">
      <template #head>
        <div class="opc-zm-base-card__head">
          <div class="opc-zm-base-card__head-left">
            <img class="opc-zm-base-card__logo" :src="logo" :alt="title" tabindex="-1" />
          </div>
          <div :class="['opc-zm-base-card__head-right', ...headClassForSchool]">
            <div class="opc-zm-base-card__head-right-content">
              <h2 :class="['opc-zm-base-card__name', isSchool ? '' : 'text-capitalize']">
                {{ title }}
              </h2>
              <div class="opc-zm-base-card__view-detail-button" v-if="!isCartBuilderAddQty">
                <zm-button data-testid="checkout-button-128" class="opc-zm-base-card__link" type="link" @click="handlePlanDetails"
                  v-if="isExpanded && showPlanDetail">
                  {{ isEdu2Esc? $t('billing.zone.explore_other_plans_edit') : $t('billing.plan_details') }}
                </zm-button>
              </div>
            </div>
            <div class="opc-zm-base-card__collapse opc-zm-base-card__collapse--reset" v-if="!isExpanded && formPlan">
              <p v-for="item in collapseTextArrayGet" :key="item.key" v-html="item.text"></p>
            </div>
          </div>
        </div>
      </template>
      <div class="opc-zmone__main">
        <multiple-meeting-form v-if="toMSQUI" :ctx="ctx" />
        <zm-form ref="zmoneForm" label-position="top" class="opc-config-form" @submit.prevent v-else>
          <zm-form-item class="opc-zmone__form-item--license">
            <p class="opc-zmone__form-label" >
              <span v-if="isCartBuilderAddQty">{{ $t('billing.delta.add_user') }}</span>
              <span v-else>{{ $t('billing.zone.select_license') }}</span>
              <zm-tooltip v-if="!isCartBuilderAddQty" @show="toggleAttendeeTip(true)" @hide="toggleAttendeeTip(false)" class="item opc-zmone__numbers-users-tooltip"
                disallow-learn-about
                aria-label="Learn more about Select the number of users"
                placement="top">
                <tips-icon aria-label="Learn more about Select the number of users" />
                <template #content>
                  {{ $t('billing.zone.attendee_info', [attendee]) }}
                  <zm-button data-testid="checkout-button-129" v-if="showIncreaseWithLargeMeetingPromo" @click="addLargeMeetingCard" class="opc-zmone__tip-lm-btn" type="link">{{$t('billing.large_meeting.increase_with')}}</zm-button>
                </template>
              </zm-tooltip>
            </p>
            <template v-if="!isCartBuilderAddQty">
            <license-tip v-if="isNormalCase" :type="form.category" :number="form.selectedNumber" :additionalSpans='additionalSpans'>
              <zm-button data-testid="checkout-button-130" v-if="showExploreLink" class="opc-zmone__link" type="link"
                @click="handleExploreOtherPlansClick">{{ $t('billing.zone.explore_other_plans') }}</zm-button>
            </license-tip>
            </template>
            <InputNumberWithPopover class="opc-zmone__quantity-selector" v-model="form.selectedNumber" size="lg"
              controls-position="both" :min="minHost" :max="maxHost" @change="updatePlanLicense"
              :decrease-tips="decreaseTips" :increase-tips="increaseTips" :label="`${title} Select the number of users`"
              :data-testid="`checkout-input-license-${formPlan ? formPlan.plan_code : ''}`" />
            <div v-show="showContinueWithLargeMeetingPromotion" class="opc-zmone__lm-promotion" v-html="$t('billing.zoom_one_biz.continue_with_lm')"></div>
            <zm-banner show-close class="reason-tips" v-if="licenseTips" type="info">
              <p v-html="licenseTips"></p>
            </zm-banner>
          </zm-form-item>
          <zm-form-item :label="$t('billing.select_billing_cycle')" class="opc-config-form__billing-cycle">
            <cycle-radio-group
              v-model="form.billingCycle"
              class="opc-card-radio"
              :plans="currentFilterPlans"
              :action="switchBillingCycle"
              :aria-label="`${title} Billing Cycle`"
            >
              <zm-tooltip v-for="plan in currentFilterPlans" :key="plan.billing_cycle"
                :disabled="!(typeof billingCycleDisabled(plan) === 'string')">
                <template #content>
                  <div v-html="billingCycleDisabled(plan) || ''" />
                </template>
                <zm-radio :data-testid="`checkout-radio-billing-cycle-${plan.plan_code}`" :label="plan.billing_cycle" :disabled="!!billingCycleDisabled(plan)"
                  class="opc-zmone__radio">
                  <p class="opc-zmone__radio-title">
                    {{ $t(`billing.billing_cycle.${plan.billing_cycle}`)}}
                  </p>
                  <subscription-cycle-sub-title :billingCycle="plan.billing_cycle" :currentCategory="form.category" :showLinkMark="showAnnualTermMonthly"
                   v-if="showAnnualTermMonthly" />
                  <p class="opc-product-price-container" tabindex="-1" :aria-label="ariaPriceOfMonthForLabel(plan)">
                    <span class="opc-product-price-container__price" aria-hidden="true">{{ getFormattedPriceOfMonth(plan, { forceDiff: true }) }}</span>
                  </p>
                  <p class="opc-zmone__radio-price-unit opc-price-bill-text">
                    <span v-html="getMergedBilledText(plan.billing_cycle, plan.amount)"></span><priceVATTip />
                  </p>
                </zm-radio>
              </zm-tooltip>
            </cycle-radio-group>
          </zm-form-item>
          <PriceBillTextTips v-if="showAnnualTermMonthly" />
        </zm-form>
        <preview-payment />
        <div v-if="showSwitchToClips" class="opc-zmone__expand-lm-promo">
          <span>{{$t('billing.custom_avatars.switch_to_clips_notice')}}&nbsp;</span>
          <zm-button @click="handleNavigateToClipsPage" type="link">{{$t('billing.custom_avatars.switch_to_clips_btn')}}</zm-button>
        </div>
        <div v-else-if="showIncreaseWithLargeMeetingPromo" class="opc-zmone__expand-lm-promo">
          <span>{{$t('billing.large_meeting.promo', [attendee])}}&nbsp;</span>
          <zm-button data-testid="checkout-button-132" @click="addLargeMeetingCard" type="link">{{$t('billing.large_meeting.increase_with')}}</zm-button>
        </div>
        <div class="opc-zm-base-card__main__footer" v-if="couldBeRemovedAsAddonCard">
          <zm-button data-testid="checkout-button-133" type="link" ghost @click="removePlanByKey"
            :aria-label="'remove ' + getCategoryName(form.category) + ' plan'">{{ $t('billing.common.remove')
            }}</zm-button>
        </div>
      </div>
    </foldable>
  </tile>
  <healthcare v-if="healthcareAvailable" />
</template>
<script>
import Foldable from '@/components/foldable.vue';
import Tile from '@/components/tile.vue';
import InputNumberWithPopover from '@/components/input-number/input-number-with-popover';
import LicenseTip from '../license-tip.vue';
import {
  BILLING_CYCLE,
  limitBillingCycleWithBaseZoneTypes,
  planTypes,
  BASE_PLAN_TYPES, BillingCycleEnum,
  INDUSTRIES,
  BASE_PLAN_SUB_TYPES,
  enableProAnnualMonthlyPaymentPlanP2, enableShowAICDialog,
} from '@/common/constants';
import plansMixin from '@/plans/mx/plan';
import logo from '@/assets/plans/icon_ZM.svg';
import {
  DEFAULT_MEETING_PLAN_CAPACITY,
  getCategoryNameI18nKey,
  isBizPlusContext,
  isZoomMeetingAsAddonCard,
  ZOOM_MEETING_SUB_TYPES,
  isAutoAddable,
} from '@/plans/ZOOM_MEETING/common/utils';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { debounce, get, groupBy, throttle } from 'lodash';
import { isEmptyVal } from '@/utils';
import { getTitleNameI18nKey } from '../common/utils';
import saveMixins from '../save-mixins';
import { plansof } from '@/utils/chain';
import { getPlanTypeName } from '@/common/service/parse/parse-product-name';
import { getOnlinePlanName } from '@/common/product';
import _ from "lodash";
import { getPlanUnitWithCycle } from '@/common/product-unit';
// import { PLAN_TYPES_WITH_MULTI_BASE_PLANS } from '@/plans/ROOM_CONNECTOR/common/utils';
import autoCycle from '../mixin/auto-cycle.js';
import PreviewPayment from '@/views/checkout/payment/preview-payment';
import { isCartBuilderAddQty } from '@/utils/cart-builder';
import { getTrackingProductNameByPlanType } from '@/aspects/trackings'
import { translateToEn } from '@/plugins/i18n'
import discountedMonthPrice from '@/common/mixin/discounted-month-price';
import CmrPaywallTip, { CMR_PAYWALL_TIP_TYPES } from '@/components/cmr-paywall-tip.vue'
import ZoomMeetingDialogUtils from '../dialog/utils';
import { webinarSingleUseAllowed } from '@/common/service/op-switch';
import { getPlanTotalLicense } from '@/common/service/validate';
import {
  isFromShoppingCart,
  isProductCanRemove,
  isMeetingPlanDisabledByHasAddOn, canRemoveMeetingPlanInWinBack,
} from '@/views/config/shopping-cart/persist/plan-remove';
import EduSwitchTip from '@/components/edu-switch-tip.vue';
import { getAssignedLicenseQuantity } from '@/plans/ZOOM_ONE_BUNDLE/utils'
import { getMeetingPlanByCategory } from '@/plans/ZOOM_MEETING/common/utils';
import { validDownSellLicenseForEdu2Esc } from '@/utils/validate-downsell';
import qs from "qs";
import mxSoftBundleMeeting from "../mixin/soft-bundle-meeting";
import Healthcare from '@/plans/ZOOM_MEETING/config/healthcare/healthcare.vue';
import { logger } from '@/utils/log';
import SubscriptionCycleSubTitle from '@/plans/ZOOM_MEETING/components/subscription-cycle-sub-title.vue';
import { proAnnualMonthlyMarketingCampaignLimited } from '@/utils/annual-term-monthly-utils';
import { softBundleUtils } from '@/views/config/soft-bundle/helper';
import PriceBillTextTips from '@/plans/ZOOM_MEETING/components/price-bill-text-tips.vue';
import { ALERT_TYPE } from '@/common/constants';
import { sortPlansByCycleValue, getPlanCollapseText } from '@/common/product';
import MultipleMeetingForm from '@/plans/ZOOM_MEETING/components/multiple-meeting-form.vue';
import { pageConfig } from '@/common/service/page-config';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import AICProDialog from '@/plans/ZOOM_MEETING/components/AIC-pro-dialog.vue';
import { persistCartConstant } from '@/views/config/shopping-cart/persist/persist-cart';
import { canSwitchBillingCycle as canSwitchBillingCycleUtil } from '@/common/billing-cycle-utils';
import { checkIsShowInrDiscount, getInrProAnnualCustomPriceConfig } from '@/views/config/shopping-cart/inr-discount/inr-discount';
// import { openPlanSelectionDialogIfNeeded } from '@/plans/common/plan-selection-dialog-service';

export default {
  key: planTypes[planTypes.ZOOM_MEETING],
  components: {
    Healthcare,
    PreviewPayment,
    Foldable,
    Tile,
    InputNumberWithPopover,
    LicenseTip,
    CmrPaywallTip,
    EduSwitchTip,
    SubscriptionCycleSubTitle,
    PriceBillTextTips,
    MultipleMeetingForm,
  },
  inject: ['$core'],
  mixins: [plansMixin, saveMixins, autoCycle, discountedMonthPrice, mxSoftBundleMeeting],
  data() {
    return {
      logo,
      attendeeInfoTooltip: false,
      isExpanded: true,
      form: {...DEFAULT_MEETING_PLAN_CAPACITY},
      BILLING_CYCLE: BILLING_CYCLE,
      showPlanDetail: false,
      showCategoryDesc: false,
      isInitUpdateForm: false,
      notification: '',
      isBizPlusContext,
      isCartBuilderAddQty,
      canExpand: true,
      ALERT_TYPE: Object.freeze(ALERT_TYPE),
      aicProDialogInstance: null,
    };
  },
  created() {
    this.updateForm(true);
    this.$context.$on('notify-meeting', message => {
      this.notification = message;
    });

    ZoomMeetingDialogUtils.install(this.formPlan);
  },
  beforeUnmount() {
    this.$context.$off('notify-meeting');
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters([
      'assignInfo',
      'boughtPlans',
      'getSelectedPlans',
      'getUserCurrentSubscriptions',
      'limitLicenseWithBaseZoneTypes',
      'getCurrentBasePlanInfo', 'plansofBizBundle', 'addedTrialToPaidBasePlanList',
      'getBoughtMeetingPlans', 'healthcareAvailable',
      'freeTrialPlans', 'basicConfig', 'msqFeatureEnabled',
      'multipleSubscriptionScope',
    ]),

    isMultipleMeetingNow() {
      return this.getUserCurrentSubscriptions.filter(p => p.type === planTypes.ZOOM_MEETING)
        .filter(p => !p.isFreeTrial && !p.isOnlineFreeTrial)
        .length > 1;
    },

    isMultipleMeetingAccount() {
      return this.basicConfig.multiSubscriptionEnabled;
    },
    selectedMeetingPlans() {
      return this.getSelectedPlans.filter(p => p.type === planTypes.ZOOM_MEETING)
        .map(p => {
          if (checkIsShowInrDiscount(p)) {
            const { priceChangeRatio } = getInrProAnnualCustomPriceConfig();
            const chargeAmount = p.amount * (1 + priceChangeRatio / 100);
            return {
              ...p,
              chargeAmount
            }
          }
          return p
        })
    },
    hasNonStandardBillingCycle() {
      return !![...this.boughtPlans, ...this.getSelectedPlans]
      .filter(p => p.type === planTypes.ZOOM_MEETING)
      .some(p => ![BILLING_CYCLE.ANNUAL, BILLING_CYCLE.MONTHLY].includes(p.billing_cycle));
    },
    toMSQUI() {
      const hasFreeTrialPlan = this.getSelectedPlans.some(p => p.isOnlineFreeTrial);
      return (
        this.msqFeatureEnabled &&
        !hasFreeTrialPlan &&
        this.multipleSubscriptionScope.some(scope => (
          scope.type === planTypes.ZOOM_MEETING &&
          scope.category === this.form.category &&
          scope.flows.includes(pageConfig.type)
        ))
      )
    },
    supportMSQ() {
      return this.toMSQUI && !this.hasNonStandardBillingCycle;
    },
    ctx() {
      return {
        showIncreaseWithLargeMeetingPromo: this.showIncreaseWithLargeMeetingPromo,
        minHost: this.minHost,
        maxHost: this.maxHost,
        decreaseTips: this.decreaseTips,
        increaseTips: this.increaseTips,
        title: this.title,
        currentPlans: this.currentPlans,
        currentFilterPlans: this.currentFilterPlans,
        showAnnualTermMonthly: this.showAnnualTermMonthly,
        supportMSQ: this.supportMSQ,
        toMSQUI: this.toMSQUI,
        hasNonStandardBillingCycle: this.hasNonStandardBillingCycle,
        isCartBuilderAddQty: this.isCartBuilderAddQty,
        isNormalCase: this.isNormalCase,
        additionalSpans: this.additionalSpans,
        showExploreLink: this.showExploreLink,
        licenseTips: this.licenseTips,

        billingCycleDisabled: this.billingCycleDisabled.bind(this),
        ariaPriceOfMonthForLabel: this.ariaPriceOfMonthForLabel.bind(this),
        getFormattedPriceOfMonth: this.getFormattedPriceOfMonth.bind(this),
        getPriceOfMonth: this.getPriceOfMonth.bind(this),
        getMergedBilledText: this.getMergedBilledText.bind(this),
        useSmallSize: this.useSmallSize.bind(this),
        getBillingCycleDisabledDesc: this.getBillingCycleDisabledDesc.bind(this),
        handleExploreOtherPlansClick: this.handleExploreOtherPlansClick.bind(this),

        __configRef: this,
      }
    },
    cmrPaywallTipType() {
      switch (this.form.category) {
        case ZOOM_MEETING_SUB_TYPES.PRO:
          return CMR_PAYWALL_TIP_TYPES.PRO
        case ZOOM_MEETING_SUB_TYPES.BIZ:
          return CMR_PAYWALL_TIP_TYPES.BIZ
        default:
          return ''
      }
    },
    isNormalCase() {
      return true;
    },
    additionalSpans() {
      return {};
    },
    showExploreLink() {
      return false;
    },
    showContinueWithLargeMeetingPromotion() {
      return false
    },
    title() {
      return this.$t(this.formPlan?.planNameKey)
    },
    zmAsBasePlan() {
      const key = this.$options.key;
      const planType = planTypes[key];
      return this.getCurrentBasePlanInfo.planType === planType;
    },
    zmIsLastBasePlan() {
      const key = this.$options.key;
      const planType = planTypes[key];
      let baseTypes = plansof(this.getSelectedPlans).type(...BASE_PLAN_TYPES).get().map(x => x.type);
      // 1. is last base plan, e.g. CRC could have more than 1 bas plan
      // 2. zm must as base plan, e.g. Scheduler no need zoom meeting as base plan
      return (baseTypes.length === 1 && baseTypes[0] === planType) && this.zmAsBasePlan
    },
    couldBeRemovedAsAddonCard() {
      const disabled = isMeetingPlanDisabledByHasAddOn(planTypes.ZOOM_MEETING);
      if (disabled) {
        return false;
      }
      if (this.soft_bundle_hiddenPlanCardRemove) {
        return false;
      }

      if(isFromShoppingCart()) {
        return isProductCanRemove(this.currentPlans[0])
      }

      if (softBundleUtils.isSimilarPbxBundle() && (this.$context.is.buyNow || this.$context.is.basic2pro)) {
        return true;
      }

      return isZoomMeetingAsAddonCard() && !this.zmIsLastBasePlan || isBizPlusContext || this.couldBeRemovedInEducation || canRemoveMeetingPlanInWinBack(planTypes.ZOOM_MEETING,this.cartMeetingPlan?.zoomMeetingCategory);
    },
    couldBeRemovedInEducation() {
      return this.$context.is.edu && [planTypes.ZOOM_PHONE, planTypes.ZOOM_ROOMS].includes(this.$context.type);
    },
    zonePlans() {
      return this.planMapFlat.filter((item) => item.type === planTypes.ZOOM_MEETING);
    },
    zonePlanGroupByCategory() {
      return groupBy(this.zonePlans, 'category');
    },
    showAnnualTermMonthly() {
      return this.currentPlansHasAnnualTermMonthly && !proAnnualMonthlyMarketingCampaignLimited() && !this.isMultipleMeetingAccount;
    },
    currentPlansHasAnnualTermMonthly() {
      return enableProAnnualMonthlyPaymentPlanP2 && this.currentPlans.some((item) => item.billing_cycle === BILLING_CYCLE.ANNUAL_TERM_MONTHLY);
    },
    currentFilterPlans() {
      // Filter plans if needed
      // multiple subscription account don't support annual term monthly
      if (proAnnualMonthlyMarketingCampaignLimited() || this.isMultipleMeetingAccount) {
        return sortPlansByCycleValue(this.currentPlans.filter((item) => item.billing_cycle !== BILLING_CYCLE.ANNUAL_TERM_MONTHLY));
      }

      return sortPlansByCycleValue(this.currentPlans);
    },
    freeTrialPlansHasZoomRoom() {
      return this.freeTrialPlans.find(p => p.category === BASE_PLAN_SUB_TYPES.ZOOM_ROOM)
    },
    currentPlans() {
      return this.zonePlanGroupByCategory[this.form.category];
    },
    annualPriceM() {
      const monthPlan = this.currentPlans.find((item) => item.billing_cycle === BILLING_CYCLE.MONTHLY);
      return monthPlan ? monthPlan.amount * 12 : 0;
    },
    annalPriceSave() {
      const annualPlan = this.currentPlans.find((item) => item.billing_cycle === BILLING_CYCLE.ANNUAL);
      if (this.annualPriceM && annualPlan) {
        return this.annualPriceM - annualPlan.amount;
      }
      return 0;
    },
    saveLabel() {
      return {
        [BILLING_CYCLE.MONTHLY]: '',
        [BILLING_CYCLE.ANNUAL]: this.annalPriceSave > 0
          ? `${this.$money(this.annalPriceSave)} ${this.$t('billing.annual_save')}`
          : '',
      };
    },
    // current selected meeting plan
    formPlan() {
      return this.zonePlanGroupByCategory[this.form.category].find(
        (item) => item.billing_cycle === this.form.billingCycle,
      );
    },
    totalCoast() {
      if (this.formPlan) {
        return this.formPlan.amount * this.form.selectedNumber;
      }
      return 0;
    },
    exceedBaseLicensePlans() {
      return this.getUserCurrentSubscriptions.filter(item => (
        (item.billing_cycle !== BILLING_CYCLE.ONE_TIME || item?.considerLicenseLimit) &&
        _.includes(this.limitLicenseWithBaseZoneTypes, item.type) &&
        item.cartInfo.selected_number >= this.form.selectedNumber
      ));
    },
    annualAddonPlans() {
      const newLimit = [];
      return this.getUserCurrentSubscriptions.filter(item => (
        limitBillingCycleWithBaseZoneTypes.concat(newLimit).includes(item.type) &&
        item.billing_cycle === BILLING_CYCLE.ANNUAL
      ));
    },
    maxAddonLicense() {
      return this.exceedBaseLicensePlans.reduce((license, plan) => Math.max(plan.cartInfo.selected_number, license), 0);
    },
    assignedEduLicenseQuantity() {
      const boughtMeetingPlan = getMeetingPlanByCategory(this.boughtPlans, BASE_PLAN_SUB_TYPES.EDUCATION);
      return getAssignedLicenseQuantity([boughtMeetingPlan], this.assignInfo);
    },
    // if the use has custom avatars, it means they already have base plan.So we need minus this quantity
    getCustomAvatarsLicense () {
      const customAvatarsPlan = this.getUserCurrentSubscriptions.find(item => item.type === planTypes.CUSTOM_AVATARS);
      return customAvatarsPlan?.cartInfo?.selected_number ?? 0;
    },
    minHost() {
      if(this.$context.is.fromPersistentCart) {
        if(plansof(this.getSelectedPlans).type(planTypes.ZOOM_ONE_BUNDLE).has()) return 1;
      };
      if(isCartBuilderAddQty) return 1;
      if(isBizPlusContext) return 1;
      if(this.supportMSQ && this.isMultipleMeetingNow) return 1;
      const planMin = this.formPlan ? this.formPlan.min : 1;
      if (isAutoAddable()) {
        if(this.basicConfig.isExpireAccountWithPaidPlan){
          return 1;
        };
        return getPlanTotalLicense(this.getBoughtMeetingPlans) || planMin;
      }
      if(this.$context.is.pro2biz) {
        return Math.max(getPlanTotalLicense(this.getBoughtMeetingPlans), planMin);
      }
      if (this.$context.is.add2cart) {
        const { bundleLicenses } = this.plansofBizBundle;
        const customAvatarsLicense = this.getCustomAvatarsLicense;
        if (bundleLicenses > 0) {
          return Math.max(Math.min(planMin, this.maxAddonLicense - bundleLicenses), 1);
        }
        if(customAvatarsLicense > 0) {
          return Math.max(Math.min(planMin, this.maxAddonLicense - bundleLicenses - this.getCustomAvatarsLicense), 1);
        }
      }
      if (this.$context.is.edu2esc) {
        if(this.assignedEduLicenseQuantity > planMin){
          return Math.max(planMin, this.assignedEduLicenseQuantity);
        }
      }
      return Math.max(planMin, this.maxAddonLicense);
    },
    maxHost() {
      if(isCartBuilderAddQty) return 9999;
      if(this.$context.is.edu2esc) return 9999;
      return this.formPlan ? this.formPlan.max : 99;
    },
    decreaseTips() {
      if(this.$context.is.fromPersistentCart) {
        if(plansof(this.getSelectedPlans).type(planTypes.ZOOM_ONE_BUNDLE).has()) return '';
      };
      if(isBizPlusContext) return '';
      if(this.isMultipleMeetingNow) return '';
      const planGroupByType = groupBy(this.exceedBaseLicensePlans, 'type');
      const typeNames = Object.keys(planGroupByType).map(type => {
        const typeNameKey = get(planGroupByType[type], '0.typeNameKey', '');
        return this.$t(typeNameKey);
      }).filter(Boolean);
      if (this.$context.is.add2cart) {
        const { bundleLicenses } = this.plansofBizBundle;
        if (bundleLicenses > 0) {
          return this.form.selectedNumber <= this.maxAddonLicense - bundleLicenses ? this.$t('billing.licences_limit_tips', [typeNames.join(','), this.$t('billing.planform.title.zoom_meeting_zoomonenew')]) : '';
        }
      }
      if(isAutoAddable()) return ''
      return this.form.selectedNumber <= this.maxAddonLicense ? this.$t('billing.licences_limit_tips', [typeNames.join(','), this.$t('billing.planform.title.zoom_meeting_zoomonenew')]) : '';
    },
    increaseTips() {
      return ''
    },
    attendee() {
      return get(this.currentPlans, "[0].participants", 0);
    },
    trackingPlanName() {
      if (this.$context.is.edu) {
        return this.$t(getTitleNameI18nKey(this.form?.category));
      }
      else if (this.isSchool) {
        return translateToEn(this.formPlan?.planNameKey);
      }
      else {
        return this.$t(`Zoom One ${this.form?.category}`);
      }
    },
    licenseAlertDesc() {
      return ""
    },
    mx_defLicenseAlertDesc() {
      const configPlan = plansof(this.getSelectedPlans).type(this.$context.type).get(0);
      const meetingPlan = plansof(this.getSelectedPlans).type(planTypes.ZOOM_MEETING).get(0);
      // FREE TRIAL - Pro free trial need to be upgrade with a add plan
      const isCurrentFlowWithBaseFreeTrialPlanUpgraded = (this.addedTrialToPaidBasePlanList || []).length > 0;;
      if(isCurrentFlowWithBaseFreeTrialPlanUpgraded) {
        const originalBaseFreeTrialPlan = this.getBoughtMeetingPlans[0];
        if (
          Array.isArray(configPlan.licenseDependBasePlanTypeList) &&
          !configPlan.isPPA &&
          configPlan.licenseDependBasePlanTypeList.includes(planTypes.ZOOM_MEETING)
        ) {
          return this.$t("billing.common.license_equal_to_base", [
            getOnlinePlanName(meetingPlan),
            this.$t(getPlanTypeName(this.$context.type))
          ])
        }
        return this.$t("billing.trial.paid_plan_required_when_add_plans", [
          this.$t(getPlanTypeName(this.$context.type)),
          getOnlinePlanName(meetingPlan),
          this.$t('billing.trial.title', [getOnlinePlanName(originalBaseFreeTrialPlan)]),
        ])
      }

      const { licenseDependBasePlanTypeList = [] } = configPlan;
      const isRequired = licenseDependBasePlanTypeList.includes(planTypes.ZOOM_MEETING);
      if (isRequired) {
        if([planTypes.CUSTOM_AVATARS].includes(this.$context.type)) {
          return this.$t("billing.custom_avatars.zoom_meeting_alert_desc", [this.title])
        }
        if(configPlan.isPPA || [planTypes.ROOM_CONNECTOR, planTypes.ZCM].includes(this.$context.type)) {
          return this.$t("billing.common.consumption_equal_to_base", [
            this.$t(getPlanTypeName(this.$context.type)),
            getOnlinePlanName(meetingPlan),
          ])
        } else {
          const maximumLicensePlan = _.chain(this.getSelectedPlans)
            .filter((p) => _.includes(p?.licenseDependBasePlanTypeList, planTypes.ZOOM_MEETING))
            .orderBy((p) => p?.cartInfo?.selected_number, "desc")
            .get(0)
            .value();

          const typeName = this.$t(getPlanTypeName(maximumLicensePlan?.type || this.$context.type));
          if (webinarSingleUseAllowed && (maximumLicensePlan?.type === planTypes.WEBINAR || this.$context.type === planTypes.WEBINAR)) {
            return this.$t("billing.common.license_equal_to_base_for_webinar", [
              getOnlinePlanName(meetingPlan),
              typeName,
            ])
          }
          return this.$t("billing.common.license_equal_to_base", [
            getOnlinePlanName(meetingPlan),
            typeName,
          ])
        }
      }

      // For some plans like CRC, only need at least 1 license of base plan
      const { dependBasePlanTypeList = [] } = configPlan;
      const isJustBasePlanRequired = dependBasePlanTypeList.includes(planTypes.ZOOM_MEETING);
      if (isJustBasePlanRequired) {
        // if(PLAN_TYPES_WITH_MULTI_BASE_PLANS.includes(this.$context.type)) {
        return this.$t("billing.common.consumption_equal_to_base", [
          this.$t(getPlanTypeName(this.$context.type)),
          getOnlinePlanName(meetingPlan),
        ])
        // }
      }
      return "";
    },
    cartMeetingPlan() {
      return this.getSelectedPlans.find((item) => item.type === planTypes.ZOOM_MEETING);
    },
    licenseTips() {
      // if (this.needUnAssignTips && this.isEdu2Esc) {
      //   return this.needUnAssignTips;
      // }
      return '';
    },
    isSchool() {
      return this.form?.category === ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP
    },
    headClassForSchool() {
      if (this.isSchool) {
        if (this.isExpanded) {
          return ['opc-zm-base-card__head-right__for_school--expand'];
        } else {
          return ['opc-zm-base-card__head-right__for_school--collapse'];
        }
      }
      return [];
    },
    showSwitchToClips () {
      return false;
    },
    showIncreaseWithLargeMeetingPromo() {
      return false
    },
    showLargeMeetingPromoInComparison() {
      return false
    },
    isEdu2Esc(){
      return this.$context.is.edu2esc
    },
    needUnAssignTips() {
      const boughtMeetingPlan= getMeetingPlanByCategory(this.boughtPlans, BASE_PLAN_SUB_TYPES.EDUCATION)|| '';
      return validDownSellLicenseForEdu2Esc({ quantity: this.form.selectedNumber } ,boughtMeetingPlan )?.errorMessage;
    },
    collapseTextArrayGet() {
      return this.selectedMeetingPlans.map(plan => ({
        key: plan?.plan_code,
        text: getPlanCollapseText({
          amount: plan?.chargeAmount ?? plan?.amount,
          billingCycle: plan?.billing_cycle,
          quantity: plan?.cartInfo?.selected_number,
          cycleValue: plan?.cycleValue,
          unit: plan?.unit,
        }),
      }));
    }
  },
  mounted() {
    this.$context.$on('collapse-plan-card', this.collapseCard);
    this.$context.$on('plan-card-event', this.handlePlanCardEvent);
    if (this.shouldOpenAICDialog()) {
      this.aicProDialogInstance = new ServiceConfirm(AICProDialog)
      this.aicProDialogInstance.confirm()
    }
    // openPlanSelectionDialogIfNeeded();
  },
  methods: {
    ...mapActions(['switchBillingCycleAction']),
    ...mapMutations(['updateSelectPlan', 'savePersist', 'removePlan', 'setPreventAutoCollapseOnce']),
    toggleAttendeeTip(val) {
      this.attendeeInfoTooltip = val;
    },
    shouldOpenAICDialog() {
      // feature flag from back-end system property
      // key: billing.enable.feature.enableShowAICDialog
      if (!enableShowAICDialog) {
        return false;
      }
      const isFlowMatched = this.$context.is.buyNow || this.$context.is.basic2pro;
      if (!isFlowMatched) {
        return false;
      }
      const params = new URLSearchParams(window.location.search);
      return params.get('source') === 'aicbasic';
    },
    handlePlanCardEvent(e) {
      this.aicProDialogInstance.destroy();
      const { event } = e
      if (event === 'addLargeMeeting') {
        this.$core.addon(planTypes[planTypes.LARGE_MEETING])
      }
    },
    // sync shopping cart plan to local form state
    updateForm(isInitUpdateForm = false) {
      const shoppingCartPlan = this.cartMeetingPlan;
      if (shoppingCartPlan) {
        this.form.category = shoppingCartPlan.category;
        this.form.billingCycle = shoppingCartPlan.billing_cycle;
        this.form.selectedNumber = shoppingCartPlan.cartInfo.selected_number;
      }

      this.isInitUpdateForm = isInitUpdateForm;
    },
    async switchBillingCycle(oldPlan, newPlan) {
      if (!this.formPlan) {
        return;
      }

      const cartInfo = { selected_number: this.form.selectedNumber };
      await this.switchBillingCycleAction([oldPlan?.plan_code, {
        ...newPlan,
        cartInfo,
      }]);

      this.updateForm();

      this.switchOtherPlanCycle4SoftBundle(this.form.billingCycle);
    },
    updatePlanLicense: throttle(function (v) {
      this.$nextTick(async () => {
        if (!this.formPlan) {
          return;
        }

        if (isEmptyVal(v)) {
          this.form.selectedNumber = Math.max(this.formPlan?.cartInfo?.selected_number ?? 0, this.minHost);
        }

        this.updateSelectPlan({
          ...this.formPlan,
          cartInfo: {
            selected_number: this.form.selectedNumber,
          },
        });

        this.updateForm();
      });
    }, 200),
    addLargeMeetingCard() {
      // V3-TODO edu plan details add large meeting
      this.setPreventAutoCollapseOnce(true);
      this.attendeeInfoTooltip = false
      this.$core.addon(planTypes[planTypes.LARGE_MEETING])
    },
    async handlePlanDetailsClick() {
      try {
        if (this.$context.is.edu) {
          let buyInteraction = 'plan details selected',
            buySelection = this.trackingPlanName;
          if (this.$context.type === planTypes.WEBINAR) {
            buyInteraction = `${getTrackingProductNameByPlanType(planTypes.WEBINAR)} add-ons`;
            buySelection = `${this.trackingPlanName} - plan details selected`;
          } else if (this.$context.type === planTypes.ZOOM_PHONE) {
            buyInteraction = `${getTrackingProductNameByPlanType(planTypes.ZOOM_PHONE)} add-ons`;
            buySelection = `${this.trackingPlanName} - plan details selected`;
          }
          this.$tracking.buyInteraction(buyInteraction, buySelection);
        } else {
          this.$tracking.buyInteraction('plan details selected', `${this.trackingPlanName}${this.healthcareAvailable ? ` ${INDUSTRIES.HEALTHCARE}` : ''}`);
        }

        if (this.soft_bundle_hiddenSwitchCategoryEntry) {
          await ZoomMeetingDialogUtils.showPlanDetail({
            largeMeetingCb: this.$context.is.basic2pro || this.$context.is.buyNow
              ? this.addLargeMeetingCard.bind(this) : null,
            planCategory: this.formPlan.category
          });
        } else {
          await this.showFullComparisonDialog();
        }
      } catch (e) {
        logger.warn("zoom meeting handlePlanDetailsClick", e);
      }
    },
    async handleExploreOtherPlansClick() {
      try {
        this.$tracking.buyInteraction('explore other plans', `${this.trackingPlanName} - explore other plans`);
        if (this.healthcareAvailable) {
          const trackingPlanName = translateToEn(getTitleNameI18nKey(this.form?.category))
          const bannerText = translateToEn('billing.zone.max_of_pro_99')
          this.$tracking.buyInteraction(
            'banner - product level',
            `${trackingPlanName} ${INDUSTRIES.HEALTHCARE} - ${bannerText} - explore other plans`,
          )
        }
        await this.showFullComparisonDialog();
      } catch (e) {
        logger.warn("zoom meeting handleExploreOtherPlansClick", e);
      }
    },
    async showFullComparisonDialog() {
      this.$tracking.buyInteraction('product details', `${this.healthcareAvailable ? `${translateToEn(getTitleNameI18nKey(this.form?.category))} ${INDUSTRIES.HEALTHCARE} ` : ''}full plan comparison - impression`);
      await ZoomMeetingDialogUtils.showComparisonDialog({
        planCategory: this.formPlan.category,
        largeMeetingConfig: {
          pro: {
            callback: this.addLargeMeetingCard.bind(this),
            display: this.showLargeMeetingPromoInComparison,
            disabled: this.formPlan.category !== ZOOM_MEETING_SUB_TYPES.PRO,
          },
          proPlus: {
            callback: this.addLargeMeetingCard.bind(this),
            display: this.showLargeMeetingPromoInComparison,
            disabled: this.formPlan.category !== ZOOM_MEETING_SUB_TYPES.PRO_PLUS,
          },
          business: {
            callback: this.addLargeMeetingCard.bind(this),
            display: this.showLargeMeetingPromoInComparison,
            disabled: this.formPlan.category !== ZOOM_MEETING_SUB_TYPES.BIZ,
          },
          businessPlus: {
            callback: this.addLargeMeetingCard.bind(this),
            display: this.showLargeMeetingPromoInComparison,
            disabled: this.formPlan.category !== ZOOM_MEETING_SUB_TYPES.BIZ_PLUS,
          },
          school: {
            callback: this.addLargeMeetingCard.bind(this),
            disabled: false,
            display: this.$context.is.basic2pro || this.$context.is.buyNow
          },
          schoolPlus: {
            callback: () => {},
            disabled: true,
            display: this.$context.is.basic2pro || this.$context.is.buyNow
          },
        }
      });
      this.$nextTick(() => this.updateForm());
    },
    getCategoryName(category) {
      return this.$t(getCategoryNameI18nKey(category));
    },
    getBillingCycleDisabledDesc(billingCycle, removeMode = false) {
      if (this.isMultipleMeetingNow) {
        return ![BILLING_CYCLE.ANNUAL, BILLING_CYCLE.MONTHLY].includes(billingCycle);
      }
      // from auto-cycle.js
      if (this.autoDisabledCycle(billingCycle)) {
        return this.isAutoDisabledCycleDesc;
      }
      if (this.form.billingCycle === billingCycle && billingCycle === BILLING_CYCLE.ANNUAL) {
        return false;
      }
      // Skip exceed addon plans check if coming from shopping cart and addon can be supported by other base plans
      if (persistCartConstant.enablePersistShoppingBagForV2 && this.canSwitchBillingCycle(billingCycle)) {
        // Continue to subsequent logic
      } else {
        const exceedAddonPlans = this.getExceedCycleAddonPlans(BillingCycleEnum[billingCycle]);
        const planGroupByType = groupBy(exceedAddonPlans, 'type');
        const typeNames = Object.keys(planGroupByType).map(type => {
          const typeNameKey = get(planGroupByType[type], '0.typeNameKey', '');
          return this.$t(typeNameKey);
        }).filter(Boolean);
        if (exceedAddonPlans.length) {
          if(billingCycle === BILLING_CYCLE.MONTHLY){
            const key = removeMode ? 'billing.planform.annual_base_remove_disable_tooltip' : 'billing.planform.monthly_base_disable_tooltip'
            return this.$t(key, [typeNames.join(','), this.$t('billing.planform.title.zoom_meeting_zoomonenew')]);
          }else {
            return true;
          }
        }
      }
      return false;
    },
    billingCycleDisabled({ billing_cycle, disabled }) {
      return this.getBillingCycleDisabledDesc(billing_cycle) || disabled === true;
    },
    getPlanUnitWithCycle(cycle) {
      return getPlanUnitWithCycle(cycle);
    },
    getExceedCycleAddonPlans(cycleValue) {
      const newLimit = [];
      return this.getUserCurrentSubscriptions.filter(item => (
        limitBillingCycleWithBaseZoneTypes.concat(newLimit).includes(item.type) &&
        item.cycleValue > cycleValue
      ));
    },
    canSwitchBillingCycle(targetBillingCycle) {
      return canSwitchBillingCycleUtil({
        currentSubscriptions: this.getUserCurrentSubscriptions,
        currentBasePlanType: planTypes.ZOOM_MEETING,
        targetBillingCycle,
      });
    },
    collapseCard() {
      this.isExpanded = false;
    },
    licenseAlertMouseoverEventTrack() {
      if (this.$context.is.edu) {
        let buyInteraction = 'banner - product level',
          buySelection = this.trackingPlanName + ' - ' + this.licenseAlertDesc + ' - impression',
          curPlanName = ''
        if (this.$context.type === planTypes.WEBINAR) {
          curPlanName = getTrackingProductNameByPlanType(planTypes.WEBINAR);
          buySelection = `${curPlanName} - ${this.trackingPlanName} - ${this.licenseAlertDesc} - impression`;
        } else if (this.$context.type === planTypes.ZOOM_PHONE) {
          curPlanName = getTrackingProductNameByPlanType(planTypes.ZOOM_PHONE);
          buySelection = `${curPlanName} - ${this.trackingPlanName} - ${this.licenseAlertDesc} - impression`;
        }
        this.$tracking.buyInteraction(buyInteraction, buySelection);
      } else {
        let buySelection = `${this.trackingPlanName} - ${this.licenseAlertDesc} - impression`
        if (this.$context.type === planTypes.ZCM) {
          const curTrackingPlanName = getTrackingProductNameByPlanType(get(planTypes, planTypes.ZCM));
          buySelection = `${curTrackingPlanName} - ${this.licenseAlertDesc} - impression`
        }
        this.$tracking.buyInteraction('banner - product level', buySelection)
      }
    },
    handlePlanDetails(){
      this.isEdu2Esc? this.handleExploreOtherPlansClick() : this.handlePlanDetailsClick()
    },
    handleNavigateToClipsPage () {
      // use universal link, basic2Pro or buyNow flow
      const customAvatarsWithClipsLink = "/buy";
      const searchQueryParams = {
        plan: "zclips",
        period: "monthly",
        product: "CUSTOMAVATARS",
        usageType: "business"
      }
      const finalLink = `${customAvatarsWithClipsLink}?${qs.stringify(searchQueryParams)}`;
      // window.location.href = finalLink;
      location.replace(finalLink);
    }
  },
  watch: {
    supportMSQ: {
      immediate: true,
      handler(val) {
        if (!val) {
          const plan = this.selectedMeetingPlans[1]
          plan && this.removePlan(plan.plan_code);
        }
      }
    },
    attendeeInfoTooltip: {
      handler(val) {
        if (val) {
          if (this.$context.is.edu) {
            let buyInteraction = `${this.trackingPlanName} options`,
              buySelection = 'number of licenses - tooltip';
            if (this.$context.type === planTypes.WEBINAR) {
              buyInteraction = `${getTrackingProductNameByPlanType(planTypes.WEBINAR)} add-ons`;
              buySelection = `${this.trackingPlanName} options - ${buySelection}`;
            } else if (this.$context.type === planTypes.ZOOM_PHONE) {
              buyInteraction = `${getTrackingProductNameByPlanType(planTypes.ZOOM_PHONE)} add-ons`;
              buySelection = `${this.trackingPlanName} options - ${buySelection}`;
            }
            this.$tracking.buyInteraction(buyInteraction, buySelection);
          } else {
            this.$tracking.buyInteraction(
              `${this.trackingPlanName} options`,
              'number of users - tooltip'
            );
          }
        }
      }
    },
    isExpanded: {
      handler(val) {
        if (this.$context.is.edu) {
          let buyInteraction = 'product details accordion',
            buySelection = `${this.trackingPlanName} - ${val ? 'expand' : 'collapse'}`;
          if (this.$context.type === planTypes.WEBINAR) {
            buyInteraction = `${getTrackingProductNameByPlanType(planTypes.WEBINAR)} add-ons`;
            buySelection = `${this.trackingPlanName} - product details accordion - ${val ? 'expand' : 'collapse'}`;
          } else if (this.$context.type === planTypes.ZOOM_PHONE) {
            buyInteraction = `${getTrackingProductNameByPlanType(planTypes.ZOOM_PHONE)} add-ons`;
            buySelection = `${this.trackingPlanName} - product details accordion - ${val ? 'expand' : 'collapse'}`;
          }
          this.$tracking.buyInteraction(buyInteraction, buySelection);
        } else {
          this.$tracking.buyInteraction(
            'product details accordion',
            `${this.trackingPlanName}${this.healthcareAvailable ? ` ${INDUSTRIES.HEALTHCARE}` : ''} - ${val ? 'expand' : 'collapse'}`,
          );
        }
      },
    },
    'form.billingCycle': {
      handler: debounce(function (val) {
        if (!this.isInitUpdateForm && this.isSchool) {
          this.$tracking.buyInteraction('subscription cycle', `${this.trackingPlanName} - ${val}`)
          return
        }

        !this.isInitUpdateForm && this.$tracking.buyInteraction(
          'billing cycle',
          `${this.trackingPlanName} - toggled billed ${val}`,
        );
        if (!this.isInitUpdateForm && this.healthcareAvailable) {
          const trackingPlanName = translateToEn(getTitleNameI18nKey(this.form?.category))
          this.$tracking.buyInteraction('subscription cycle', `${trackingPlanName} ${INDUSTRIES.HEALTHCARE} - ${val}`)
        }
      }, 500),
    },
    'form.selectedNumber': {
      handler: debounce(function (newLicense, oldLicense) {
        if (this.formPlan && !this.isInitUpdateForm) {
          // event tracking
          if (this.$context.is.edu) {
            let buyInteraction = 'number of licenses',
              buySelection = `${this.trackingPlanName} - ${newLicense > oldLicense ? 'increase' : 'decrease'} - ${newLicense}`;
            if (this.$context.type === planTypes.WEBINAR) {
              buyInteraction = `${getTrackingProductNameByPlanType(planTypes.WEBINAR)} add-ons`;
              buySelection = `${this.trackingPlanName} - number of licenses - ${newLicense > oldLicense ? 'increase' : 'decrease'} - ${newLicense}`;
            } else if (this.$context.type === planTypes.ZOOM_PHONE) {
              buyInteraction = `${getTrackingProductNameByPlanType(planTypes.ZOOM_PHONE)} add-ons`;
              buySelection = `${this.trackingPlanName} - number of licenses - ${newLicense > oldLicense ? 'increase' : 'decrease'} - ${newLicense}`;
            }
            this.$tracking.buyInteraction(buyInteraction, buySelection);
          } else {
            this.$tracking.buyInteraction(
              this.$context.is.edu ? 'number of licenses' : (this.isSchool ? 'number of users' : 'number of hosts'),
              `${this.trackingPlanName}${this.healthcareAvailable ? ` ${INDUSTRIES.HEALTHCARE}` : ''} - ${newLicense > oldLicense ? 'increase' : 'decrease'} - ${newLicense}`);
          }
        }
      }, 500),
    },
    cartMeetingPlan: {
      deep: true,
      handler() {
        this.updateForm();
      },
    }
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@/styles/zoom-card.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/scss-utils.scss';

.opc-config-form {
  &__billing-cycle {
    &.zbo-form-item {
      .zbo-form-item__row {
        display: flex;
        flex-direction: column;
      }
    }
  }
}

.opc-zmone {
  .opc-zm-base-card__head-right__for_school--expand {
    padding-right: 0px;
    .opc-zm-base-card__name {
      align-items: baseline;
      .zm-icon-success {
        align-self: initial; // force override global styles(center)
      }
    }
  }

  .opc-zm-base-card__head-right__for_school--collapse {
    padding-right: 80px;
    .opc-zm-base-card__name {
      align-items: baseline;
      .zm-icon-success {
        align-self: initial; // force override global styles(center)
      }
    }
  }

  &__link.zbo-button--text {
    font-weight: 700 !important;
    color: $theme-color;
    padding: 0;
  }

  &__quantity-selector {
    margin-top: 8px;
    @include media(mobile) {
      margin-top: 12px;
    }
  }

  &__desc {
    padding-bottom: 20px;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
  }

  &__main {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #dfdfe4;
    @include media(mobile) {
      margin-top: 16px;
      padding-top: 16px;
    }
  }

  &__desc {
    position: relative;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    color: var(--zoom-color-text-strong-neutral, #555B62);
    padding: 0;
    margin: 0;

    &.is-warning {
      padding: 8px 12px 8px 40px;
      background: var(--zoom-color-fill-subtler-warning, #FFF9F2);
      border-radius: 8px;

      &::before {
        content: '';
        background-image: url('../../../assets/Alert.svg');
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-size: cover;
        position: absolute;
        top: calc(50% - 8px);
        left: 12px;
      }
    }
  }

  &__form-label {
    margin: 0;
    padding: 0;
    color: $zoom-color-text-stronger-neutral;
    /* title-3 */
    font-size: 16px;
    font-weight: 600;
    line-height: 20px; /* 125% */
    letter-spacing: -0.31px;
    @include media(mobile) {
      font-size: 16px;
      line-height: 24px;
    }
  }

  &__numbers-users-tooltip {
    margin-left: 4px;
  }

  &__lm-promotion {
    background: var(--zoom-color-fill-subtler-supplementary2, #D4FCFB);
    border-radius: 8px;
    padding: 8px 12px 8px 12px;
    margin-top: 16px;
    a {
      color: $theme-color;
    }
  }


  .opc-card-radio {
    margin-top: 8px;

    .opc-zmone__radio {
      .zbo-radio__wrap {
        width: 100%;
      }
      .opc-product-price-container {
        margin: 4px auto 2px;
      }
    }
  }

  .opc-card-radio &__radio {
    .zbo-radio__label--inner {
      width: 100%;
      // min-height: 136px;
      padding: 16px;
    }

    .zbo-radio__label {
      flex-direction: column;
      &.is-disabled {
        .opc-zmone__radio-title, .opc-zmone__radio-price, .opc-zmone__radio-price-unit {
          color: var(--zoom-color-state-disable, #ADB1B8) !important;
        }
      }
    }

    &-cycle-wrap {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }

    &-title {
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;

      &-billed-text {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        text-transform: lowercase;
      }

      .opc-price-save-count {
        margin-left: 4px;
      }
    }

    &-save-label {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 21px;
      color: var(--zoom-color-text-success, #247F40);
      min-width: 1px;
      min-height: 21px;
    }

    &-price {
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      line-height: 33px;

      &-unit {
        color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
      }

      &-delete {
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;
        text-decoration-line: line-through;
        color: var(--zoom-color-text-strong-neutral, #555B62);
      }
    }
  }

  &__tip-lm-btn {
    display: block;
  }

  &__expand-lm-promo {
    margin-top: 8px;
    & > span {
      color: var(--zoom-color-text-strong-neutral, #555B62);
    }
  }
}

.opc-base-alert {
  &.zbo-banner {
    margin-bottom: 16px !important;
    font-weight: 400;
  }

  &__message {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: left;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    strong {
      font-weight: bold;
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    }
  }
}

.opc-zmone {
  .opc-config-form {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    .opc-zmone__form-item--license {
      .zbo-form-item__row {
        .zbo-form-item__label-wrapper {
          height: 0px;
        }
      }
    }
  }

  .zbo-form-item__label-wrapper {
    margin-bottom: 0px;
  }
}

</style>
